// ** React Imports
import {Fragment} from 'react'

// ** Routes Imports
import AppRoutes from './Apps'
import FormRoutes from './Forms'
import PagesTemplateRoutes from './PagesTemplate'
import TablesRoutes from './Tables'
import ChartsRoutes from './Charts'
import DashboardRoutes from './Dashboards'
import UiElementRoutes from './UiElements'
import ExtensionsRoutes from './Extensions'
import PageLayoutsRoutes from './PageLayouts'
import AuthenticationRoutes from './Authentication'
import ConcessionRoutes from './Concession'
import CustomerRoutes from './Customer'
import TollSystemRoutes from './TollSystem'
import ParkingRoutes from './Parking'
import Common from './Common'

// ** Layouts
import BlankLayout from '@layouts/BlankLayout'
import VerticalLayout from '@src/layouts/VerticalLayout'
import HorizontalLayout from '@src/layouts/HorizontalLayout'
import LayoutWrapper from '@src/@core/layouts/components/layout-wrapper'

// ** Route Components
import PublicRoute from '@components/routes/PublicRoute'
import PrivateRoute from '@components/routes/PrivateRoute'

// ** Utils
import {isObjEmpty} from '@utils'

const getLayout = {
    blank: <BlankLayout/>,
    vertical: <VerticalLayout/>,
    horizontal: <HorizontalLayout/>
}

// ** Document title
const TemplateTitle = 'PagoDirecto'

// ** Default Route
const DefaultRoute = '/dashboard/ecommerce'
const DefaultSuperadminRoute = '/dashboard/superadmin'
const DefaultConcessionRoute = '/toll-system/concession/dashboard'
const DefaultUserRoute = '/customer/dashboard'

// ** Merge Routes
const Routes = [
    ...AuthenticationRoutes,
    ...DashboardRoutes,
    ...ConcessionRoutes,
    ...CustomerRoutes,
    // ...AppRoutes,
    // ...PagesRoutes,
    // ...UiElementRoutes,
    // ...ExtensionsRoutes,
    // ...PageLayoutsRoutes,
    // ...FormRoutes,
    // ...TablesRoutes,
    // ...ChartsRoutes
    ...AppRoutes,
    ...PagesTemplateRoutes,
    ...UiElementRoutes,
    ...ExtensionsRoutes,
    ...PageLayoutsRoutes,
    ...FormRoutes,
    ...TablesRoutes,
    ...ChartsRoutes,
    ...TollSystemRoutes,
    ...ParkingRoutes,
    ...Common
]

const getRouteMeta = (route) => {
    if (isObjEmpty(route.element.props)) {
        if (route.meta) {
            return {routeMeta: route.meta}
        } else {
            return {}
        }
    }
}

// ** Return Filtered Array of Routes & Paths
const MergeLayoutRoutes = (layout, defaultLayout) => {
    const LayoutRoutes = []

    if (Routes) {
        Routes.filter((route) => {
            let isBlank = false
            // ** Checks if Route layout or Default layout matches current layout
            if (
                (route.meta && route.meta.layout && route.meta.layout === layout) ||
                ((route.meta === undefined || route.meta.layout === undefined) &&
                    defaultLayout === layout)
            ) {
                let RouteTag = PrivateRoute

                // ** Check for public or private route

                if (route.meta) {
                    route.meta.layout === 'blank' ? (isBlank = true) : (isBlank = false)
                    RouteTag = route.meta.publicRoute ? PublicRoute : PrivateRoute
                }
                if (route.element) {
                    const Wrapper =
                        // eslint-disable-next-line multiline-ternary
                        isObjEmpty(route.element.props) && isBlank === false
                            ? // eslint-disable-next-line multiline-ternary
                            LayoutWrapper
                            : Fragment

                    route.element = (
                        <Wrapper {...(isBlank === false ? getRouteMeta(route) : {})}>
                            <RouteTag route={route}>{route.element}</RouteTag>
                        </Wrapper>
                    )
                }
                // Push route to LayoutRoutes
                LayoutRoutes.push(route)
            }
            return LayoutRoutes
        })
    }
    return LayoutRoutes
}

const getRoutes = (layout) => {
    // si no es enviado ningun layout por default asigna vertical
    const defaultLayout = layout || 'vertical'

    // iniciaizamos los tipos de layouts disponibles
    const layouts = ['vertical', 'horizontal', 'blank']

    const AllRoutes = []

    //
    layouts.forEach((layoutItem) => {
        // Esta funcion es la encargada de asignar el layout seleccionado de manera global a cada ruta
        // Si se desea una vista puede tener un layout por defaul (agregado en de la forma meta:{layout:"vertical"})
        const LayoutRoutes = MergeLayoutRoutes(layoutItem, defaultLayout)

        AllRoutes.push({
            path: '/',
            element: getLayout[layoutItem] || getLayout[defaultLayout],
            children: LayoutRoutes
        })
    })

    return AllRoutes
}

export {
    DefaultRoute,
    DefaultConcessionRoute,
    DefaultSuperadminRoute,
    DefaultUserRoute,
    TemplateTitle,
    Routes,
    getRoutes
}
